import { doc,  getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { auth } from "../../firebaseConfig";

export const readDataS2 = async () => {
    const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Professional Qualifications"
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      // console.log("Section 2 data:", docSnap.data());
      return docSnap.data(); // Return the form data
    } else {
      // console.log("No such document for Section 2!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 2 data: ", error);
    return null;
  }
};
